import React, { useContext } from 'react'
import CommonBox from '../CommonBox'
import SingleNoticeSection from '../SingleNoticeSection'
import GifImagesSection from '../GifImagesSection'
import LoginContext from '../../context'

const SingleNotice = () => {
    const { isAuthenticated } = useContext(LoginContext)


    return (
        <>
            <section className='single-notice'>
                <CommonBox heading=" 공지사항 " englishHeading=" notice" isEnglishHeadingOnMobile={true} isAuthenticated={isAuthenticated}>
                    <SingleNoticeSection />
                </CommonBox>
            </section>
            <section className='gif-section flex lg:hidden items-center justify-center'>
                <GifImagesSection />
            </section>
        </>
    )
}
export default SingleNotice

